var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAnnouncementLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E9EEEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.834 18.428h10.304l-1.464-2.268a.836.836 0 0 1-.132-.452v-2.96a3.585 3.585 0 0 0-3.581-3.58 3.585 3.585 0 0 0-3.582 3.58v2.96a.833.833 0 0 1-.125.44l-1.42 2.28zm11.833 1.667H8.333a.833.833 0 0 1-.707-1.274l2.087-3.351v-2.722A5.254 5.254 0 0 1 14.96 7.5a5.253 5.253 0 0 1 5.248 5.248v2.714l2.159 3.348a.835.835 0 0 1-.701 1.285z",
    fill: "#718396"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 23.15a3.06 3.06 0 0 1-3.056-3.056h1.667c0 .766.623 1.39 1.39 1.39a1.39 1.39 0 0 0 1.388-1.39h1.667A3.06 3.06 0 0 1 15 23.15z",
    fill: "#718396"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnnouncementLight);
export default __webpack_public_path__ + "static/media/ic-announcement-light.97e981dd26bfb334c48912c2fb1ad846.svg";
export { ForwardRef as ReactComponent };